import {AfterViewInit, Component, Inject, OnInit, ViewChild} from "@angular/core";

import {DOCUMENT} from "@angular/common";
import {NGXLogger} from "ngx-logger";
import {TabViewChangeEvent} from "primeng/tabview";
import {environment} from "../../../environments/environment";
import {AngularFirestore, AngularFirestoreCollection} from "@angular/fire/compat/firestore";
import { ActivatedRoute, Router } from "@angular/router";
import { Timestamp, onSnapshot } from "firebase/firestore";
import { DialogService, DynamicDialogRef } from "primeng/dynamicdialog";
import { ConfirmationService, MessageService } from "primeng/api";
import { Misurazione_Firestore } from "src/app/models/firestore/misurazioneFirestore.model";
import { ChartModule } from 'primeng/chart';
import { jwtDecode } from "jwt-decode";
import { JwtHelperService } from '@auth0/angular-jwt';
import { SecurityService } from "src/app/services/security.service";
import { Chart } from 'chart.js'; // Assicurati di importare Chart.js
import * as XLSX from 'xlsx';

@Component({
  templateUrl: "./misurazioni.component.html",
  styleUrls: ["./misurazioni.component.css"],
  providers: [DialogService, ConfirmationService],
})
export class MisurazioniComponent implements OnInit, AfterViewInit {
 
  protected isLoading: boolean = true;
  public isReady: boolean = false;
  protected showLine: boolean = false;
  protected tokenValid: boolean = false;

  protected idProgetto:number;
  protected idPunto:number;
  protected idPunti:number[]=[];
  protected isMultiPunto:boolean = false;

  protected layer:string;
  protected misurazione:Misurazione_Firestore;
  protected misurazioni:Misurazione_Firestore[]=[];
  public misurazioni_punto:Misurazione_Firestore;

  ref: DynamicDialogRef;
  options: any;
  data: any;

  @ViewChild('chart') chart: any;

  constructor(
    private logger: NGXLogger,
    private firestore: AngularFirestore,
    private router: Router,
    public dialogService: DialogService,
    private messageService:MessageService,
    private activatedRoute: ActivatedRoute,
    private securityService:SecurityService,
    @Inject(DOCUMENT) private document: Document
  ) {
   
  }

  ngOnInit() {
    this.logger.info("INIT @ MISURAZIONI");
    this.logger.info("INIT @ MISURAZIONI -  URL: " + this.document.location.href);
    const documentStyle = getComputedStyle(document.documentElement);
    const textColor = documentStyle.getPropertyValue('--text-color');
    const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
    const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

    this.options = {
      /* legend: {
        display: false       
      },
      title: {
        display: true,
        text: ''
      }, */
      maintainAspectRatio: false,
      aspectRatio: 0.6,
      plugins: {
        legend: {display:false} 
          /* legend: {
              labels: {
                  color: textColor
              }
          } */
      },
      scales: {
          x: {
              ticks: {
                  color: textColorSecondary
              },
              grid: {
                  color: surfaceBorder,
                  drawBorder: false
              }
          },
          y: {
              ticks: {
                  color: textColorSecondary
              },
              grid: {
                  color: surfaceBorder,
                  drawBorder: false
              },
              title: {
                display: true,
                text: this.activatedRoute.snapshot.paramMap.get('layer')==='VERTICALE'?'Spostamento verticale [mm]':'Spostamento lungo la LOS [mm]',
                color: textColor,
                font: {
                  weight: 'bold'
                }
              }
          }
      }
  };
  
  const urlParamIDPunto       = this.activatedRoute.snapshot.paramMap.get('idPunto');
  const urlParamIDProgetto    = this.activatedRoute.snapshot.paramMap.get('idProgetto');
  const urlParamLayer         = this.activatedRoute.snapshot.paramMap.get('layer');
 

  if(urlParamIDProgetto!=null){
    this.idProgetto = Number(urlParamIDProgetto);
  }
  if(urlParamIDPunto!=null){
    if(urlParamIDPunto.includes(',')){
      this.isMultiPunto = true;
      this.logger.info("INIT @ MISURAZIONI: MULTIPUNTO "+ urlParamIDPunto);

      urlParamIDPunto.split(',').slice(0, 10).map(id => {
        this.idPunti.push(parseInt(id, 10));
        this.logger.info("INIT @ MISURAZIONI: MULTIPUNTO SU PUNTO "+ parseInt(id, 10));
       // this.logger.info("punto "+ parseInt(id, 10));
      });
    }else{
      this.idPunto = Number(urlParamIDPunto);
      this.logger.info("INIT @ MISURAZIONI: SINGOLO PUNTO "+ this.idPunto);

    }
    
  }
  if(urlParamLayer!=null){
    this.layer = urlParamLayer;
  }
  

  this.activatedRoute.queryParams.subscribe(params => {
    //this.logger.info( params);
   /*  this.tokenValid = true;
    this.loadMisurazioniPuntoLayer(this.idProgetto, this.idPunto, (this.layer.endsWith('asc')||this.layer.endsWith('ASC'))?'ASC':(this.layer.endsWith('desc')||this.layer.endsWith('DESC'))?'DESC':'VERTICALE');
   */
   /* DA SCOMMENTARE  
   const token = params['token'];
    if (token) {
      this.validateToken(token);
    }    */
     this.tokenValid = true;
     if(!this.isMultiPunto){
      this.loadMisurazioniPuntoLayer(this.idProgetto, this.idPunto, this.layer); 
     }else{
      this.loadMisurazioniPuntiLayer(this.idProgetto, this.idPunti, this.layer); 
     }
   
    this.showLine = params['showline'] === 'true';
  });

  //https://measura.map-hosting.it/misurazione/13/200?showline=true%3EApri
  }

  

   validateToken(token:String): void {
    //this.logger.info("parte valida token "+ token);

    this.securityService.validateToken(token).subscribe({
      next: (res) => {
        this.tokenValid = true;
        this.logger.info("OK VALIDAZIONE TOKEN PER PUNTO > "+ this.idPunto + " DEL PROGETTO "+ this.idProgetto + " SU LAYER "+ this.layer);
        this.loadMisurazioniPuntoLayer(this.idProgetto, this.idPunto, this.layer);
        
      },
      error: (error) => {
        if (error.status === 401) {
          this.logger.error("Unauthorized: Token non valido o scaduto.");
        } else {
          this.logger.error("Errore nella chiamata HTTP:", error);
        }
      },
      complete: () => {
        this.logger.info("Chiamata completata.");
      }
    });
  } 


  ngAfterViewInit() {
  }

  setTimeRange(range: string) {
    if(!this.isMultiPunto){
      const labels = Object.keys(this.misurazione.misurazioni).filter(key => key !== 'ID');
      const values = labels.map(label => this.misurazione.misurazioni[label]);
      const dateLabels = labels.map(label => { 
        return new Date(
        parseInt(label.substring(1, 5)), // Anno
        parseInt(label.substring(5, 7)) - 1, // Mese (zero-based)
        parseInt(label.substring(7,9)) // Giorno
      )});
      //dateLabels.sort((a, b) => a.getTime() - b.getTime());
      let filteredLabels: string[] = [];
      let filteredValues: number[] = [];
  
      const now = new Date();
      let startDate: Date;
      
      switch (range) {
        case '1M':
          startDate = new Date();
          startDate.setMonth(startDate.getMonth() - 1);
          break;
        case '6M':
          startDate = new Date();
          startDate.setMonth(startDate.getMonth() - 6);
          break;
        case 'ALL':
         this.loadMisurazioniPuntoLayer(this.idProgetto, this.idPunto, this.layer);
         break;
      }
     
      for (let i = 0; i < dateLabels.length; i++) {
        
        if (dateLabels[i] >= startDate) {
          filteredLabels.push(labels[i]);
          filteredValues.push(values[i]);
        }
      }
      filteredLabels.sort((a, b) => {
        const dateA = parseInt(a.substring(1)); // Rimuovi la 'D' e converti in numero
        const dateB = parseInt(b.substring(1));
        return dateA - dateB; // Ordina in ordine crescente
      });
      //const values = labels.map(label => this.misurazione.misurazioni[label]);
      const formattedLabels = filteredLabels.map(label => {
        const year = label.substring(1, 5);
        const month = label.substring(5, 7);
        const day = label.substring(7, 9);
        return `${day}/${month}/${year.substring(2)}`; // Formato dd/mm/yy
      });
      
      this.data = {
        labels: formattedLabels,
        datasets: [
          {
            data: filteredValues,
            fill: false,
            borderColor: '#42A5F5',
            tension: 0.4,
            pointRadius: 3, // Dimensione dei punti
            showLine: this.showLine, // Imposta come desiderato
            borderWidth: 1
          }
        ]
      };
    }else{
      this.data = {};
          // Caso multi-punto
        const datasets: any[] = [];
        let labelsSet: Set<string> = new Set();

        this.misurazioni.forEach((misurazione, index) => {
          const labels = Object.keys(misurazione.misurazioni).filter(key => key !== 'ID');
          const values = labels.map(label => misurazione.misurazioni[label]);
          const dateLabels = labels.map(label => new Date(
            parseInt(label.substring(1, 5)),
            parseInt(label.substring(5, 7)) - 1,
            parseInt(label.substring(7, 9))
          ));
          this.logger.info(misurazione.idPunto + " range "+ range  );
          let filteredLabels: string[] = [];
          let filteredValues: number[] = [];
          let startDate: Date = this.getStartDate(range);
         


          for (let i = 0; i < dateLabels.length; i++) {
            if (dateLabels[i] >= startDate) {
              filteredLabels.push(labels[i]);
              filteredValues.push(values[i]);
            }
          }

          filteredLabels.sort((a, b) => parseInt(a.substring(1)) - parseInt(b.substring(1)));
          filteredLabels.forEach(label => labelsSet.add(label));

          datasets.push({
            label: `Punto ${misurazione.idPunto}`,
            data: filteredValues,
            fill: false,
            borderColor: this.getColor(index),
            tension: 0.4,
            pointRadius: 3,
            showLine: this.showLine,
            borderWidth: 1
          });
        });
        
        // Calcolo della media per tutti i punti in base alla data
        const labelsArray = [...labelsSet].sort((a, b) => parseInt(a.substring(1)) - parseInt(b.substring(1)));
        const mediaPerData: number[] = [];
        
        labelsArray.forEach(label => {
          let somma = 0;
          let valoriValidi = 0;
          
          this.misurazioni.forEach(misurazione => {
            const valore = misurazione.misurazioni[label];
            if (valore !== null && valore !== undefined) {
              somma += valore;
              valoriValidi++;
            }
          });
          
          mediaPerData.push(valoriValidi > 0 ? somma / valoriValidi : null);
        });
        
        // Aggiungi dataset per la media
        datasets.push({
          label: 'Media delle misurazioni',
          data: mediaPerData,
          fill: false,
          borderColor: '#000000',
          tension: 0,
          pointRadius: 0,
          borderDash: [],
          borderWidth: 4,
          showLine: true,
          zIndex: 100,
          order: 0
        });
        
        this.data = {
          labels: this.formatLabels(labelsArray),
          datasets: datasets
        };
      }
    }
 
    private getStartDate(range: string): Date {
      const now = new Date();
      let startDate = new Date();
    
      switch (range) {
        case '1M':
          startDate.setMonth(startDate.getMonth() - 1);
          break;
        case '6M':
          startDate.setMonth(startDate.getMonth() - 6);
          break;
        case 'ALL':
          startDate.setMonth(startDate.getMonth() - 240);
          // Data molto vecchia, per includere tutto
          break;
      }
    
      return startDate;
    }
    
    // Metodo per formattare le etichette delle date
    private formatLabels(labels: string[]): string[] {
      return labels.map(label => {
        const year = label.substring(1, 5);
        const month = label.substring(5, 7);
        const day = label.substring(7, 9);
        return `${day}/${month}/${year.substring(2)}`;
      });
    }
    
   

  downloadChart() {
    const chartInstance = this.chart.chart; // Ottieni l'istanza del grafico

    if (chartInstance) {
      const imageUrl = chartInstance.toBase64Image(); // Ottieni l'immagine in formato PNG
      const link = document.createElement('a'); // Crea un link per il download

      link.href = imageUrl; // Imposta il link all'immagine
      link.download = this.idProgetto+"_"+this.idPunto+'.png'; // Imposta il nome del file per il download
      link.click(); // Simula il click sul link per avviare il download
    } else {
      console.error("Errore: il grafico non è stato trovato.");
    }
  }

  /**
   * Esporta i dati mostrati nel grafico in formato Excel
   */
  exportToExcel(): void {
    try {
      let worksheetData = [];
      
      // Genera nome file con la data odierna
      const oggi = new Date();
      const giorno = oggi.getDate().toString().padStart(2, '0');
      const mese = (oggi.getMonth() + 1).toString().padStart(2, '0');
      const anno = oggi.getFullYear();
      const fileName = `Misurazioni_${this.layer.toUpperCase()}_${giorno}${mese}${anno}.xlsx`;
      
      if (!this.isMultiPunto) {
        // Caso singolo punto
        
        // Estrai i dati dal dataset
        const labels = this.data.labels;
        const values = this.data.datasets[0].data;
        
        // Intestazione estesa per singolo punto
      //  worksheetData.push(['Progetto', this.idProgetto.toString()]);
      //  worksheetData.push(['Punto', this.idPunto.toString()]);
      //  worksheetData.push(['Layer', this.layer]);
        worksheetData.push([]);
        
        // Intestazione colonne
        worksheetData.push(['Data', 'Spostamento lungo la LOS [mm]']);
        
        // Aggiunta dei dati
        for (let i = 0; i < labels.length; i++) {
          worksheetData.push([labels[i], values[i]]);
        }
      } else {
        // Caso multi-punto
        
        // Creiamo un'intestazione dinamica per tutti i punti
        const puntiHeader = ['Data'];
        this.data.datasets.forEach(dataset => {
          if (dataset.label !== 'Media delle misurazioni' && dataset.label !== 'Media di tutti i punti') {
            puntiHeader.push(dataset.label);
          }
        });
        //puntiHeader.push('Media');
        
        worksheetData.push(puntiHeader);
        
        // Prepara i dati per ogni data
        const labels = this.data.labels;
        for (let i = 0; i < labels.length; i++) {
          const row = [labels[i]];
          
          // Aggiungi i valori di ciascun punto per questa data
          this.data.datasets.forEach(dataset => {
            if (dataset.label !== 'Media delle misurazioni' && dataset.label !== 'Media di tutti i punti') {
              row.push(dataset.data[i] !== null ? dataset.data[i] : '');
            }
          });
          
          // Aggiungi il valore medio per questa data
          const mediaDataset = this.data.datasets.find(ds => 
            ds.label === 'Media delle misurazioni' || ds.label === 'Media di tutti i punti');
          
          if (mediaDataset) {
            row.push(mediaDataset.data[i] !== null ? mediaDataset.data[i] : '');
          } else {
            row.push('');
          }
          
          worksheetData.push(row);
        }
      }
      
      // Creazione del foglio Excel
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, worksheet, 'Misurazioni');
      
      // Formattazione in grassetto per le celle della media
      if (!this.isMultiPunto) {
        // Non formatta nulla per il singolo punto
      } else {
        // Formatta in grassetto l'intestazione della colonna media
        const lastCol = XLSX.utils.encode_col(worksheetData[0].length - 1);
        const mediaHeaderCell = lastCol + '1';
        worksheet[mediaHeaderCell] = { 
          t: 's', 
          v: 'Media', 
          s: { font: { bold: true, color: { rgb: '000000' } } } 
        };
        
        // Formatta in grassetto tutti i valori della colonna media
        for (let i = 1; i < worksheetData.length; i++) {
          const mediaCell = lastCol + (i + 1);
          const mediaValue = worksheetData[i][worksheetData[i].length - 1];
          
          if (mediaValue !== '') {
            worksheet[mediaCell] = { 
              t: 'n', 
              v: parseFloat(mediaValue), 
              s: { font: { bold: true } } 
            };
          }
        }
      }
      
      // Generazione del file e download
      XLSX.writeFile(workbook, fileName);
      
      this.messageService.add({
        severity: 'success',
        summary: 'Esportazione completata',
        detail: 'I dati sono stati esportati correttamente in Excel.'
      });
      
    } catch (error) {
      console.error('Errore durante l\'esportazione in Excel:', error);
      this.messageService.add({
        severity: 'error',
        summary: 'Errore',
        detail: 'Si è verificato un errore durante l\'esportazione in Excel.'
      });
    }
  }

  /* loadMisurazioniPunto (idProgetto:number, idPunto:number) {
    this.logger.info("-> loadMisurazioniPunto "+ idProgetto + "/"+idPunto);
    const collectionRef = this.firestore.collection(environment.firebase.collectionMisurazioni).ref.where('idProgetto', "==", idProgetto).where('idPunto', "==", idPunto);
    let queryMisurazioni = collectionRef;

    onSnapshot(queryMisurazioni, (qs) => {

        qs.docs.map((item) => {

          this.misurazione = item.data() as Misurazione_Firestore;
      
          let labels = Object.keys(this.misurazione.misurazioni).filter(key => key !== '\"SPAZIO\"');
          labels.sort((a, b) => {
            const dateA = parseInt(a.substring(1)); // Rimuovi la 'D' e converti in numero
            const dateB = parseInt(b.substring(1));
            return dateA - dateB; // Ordina in ordine crescente
          });
          const values = labels.map(label => this.misurazione.misurazioni[label]);
          const formattedLabels = labels.map(label => {
            const year = label.substring(1, 5);
            const month = label.substring(5, 7);
            const day = label.substring(7, 9);
            return `${day}/${month}/${year.substring(2)}`; // Formato dd/mm/yy
          });
          
          //
          //const values = labels.map(label => this.misurazione.misurazioni[`D${label.substring(6, 8)}${label.substring(3, 5)}${label.substring(0, 2)}`]);
          this.data = {
            labels: formattedLabels,
            datasets: [
              {
                //label: 'Misurazioni',
                data: values,
                fill: false,
                borderColor: '#42A5F5',
                tension: 0.4,
                pointRadius: 3,      // Dimensione dei punti
                showLine: this.showLine  ,
    
              }
            ]  
          };  
       
         
      
      });
      
    });
  } */

    loadMisurazioniPuntiLayer(idProgetto: number, idPunti: number[], layer: string) {
      this.misurazioni = [];
      const datasets: any[] = [];
      let labelsSet: Set<string> = new Set();
    
      idPunti.forEach((idPunto, index) => {
        let tripletta: string = `${idProgetto}_${idPunto}_${layer.toUpperCase()}`;
        const documentRef = this.firestore.collection(environment.firebase.collectionMisurazioni).doc(tripletta);
    
        documentRef.get().subscribe((docSnapshot) => {
          if (docSnapshot.exists) {
            const misurazione = docSnapshot.data() as Misurazione_Firestore;
            this.misurazioni.push(misurazione);
    
            let labels = Object.keys(misurazione.misurazioni).filter(key => {
              return key !== '"SPAZIO"' && key !== "//" && key !== 'PID' && key !== 'lon' && key !== 'lat';
            });
    
            labels.forEach(label => labelsSet.add(label)); // Aggiunge le date a un set per avere un range unificato
    
            labels.sort((a, b) => {
              return parseInt(a.substring(1)) - parseInt(b.substring(1));
            });
    
            const values = labels.map(label => misurazione.misurazioni[label] ?? null); // Usa null per valori mancanti
    
            datasets.push({
              label: `Punto ${idPunto}`,
              data: values,
              fill: false,
              borderColor: this.getColor(index), // Colore dinamico
              tension: 0.4,
              pointRadius: 3,
              showLine: this.showLine,
              borderWidth: 1
            });
    
            // Dopo l'ultimo punto, aggiorna il grafico
            if (datasets.length === idPunti.length) {
              this.updateChart([...labelsSet], datasets);
            }
          } else {
            this.logger.info(`-> NESSUNA MISURAZIONE PER PUNTO ${idPunto} DEL PROGETTO ${idProgetto} SU LAYER ${layer.toUpperCase()}`);
          }
        });
      });
    }
    
    private updateChart(labels: string[], datasets: any[]) {
      labels.sort((a, b) => parseInt(a.substring(1)) - parseInt(b.substring(1)));
    
      const formattedLabels = labels.map(label => {
        const year = label.substring(1, 5);
        const month = label.substring(5, 7);
        const day = label.substring(7, 9);
        return `${day}/${month}/${year.substring(2)}`;
      });
    
      // Calcolo della media per tutti i punti
      const mediaPerData: number[] = [];
      labels.forEach((_, i) => {
        let valoriValidi = 0;
        let somma = 0;
        datasets.forEach(dataset => {
          if (dataset.data[i] !== null && dataset.data[i] !== undefined) {
            somma += dataset.data[i];
            valoriValidi++;
          }
        });
        mediaPerData.push(valoriValidi > 0 ? somma / valoriValidi : null);
      });
    
      // Aggiungi dataset per la media
      datasets.push({
        label: 'Media Misurazioni',
        data: mediaPerData,
        fill: false,
        borderColor: '#000000',
        tension: 0,
        pointRadius: 0,
        borderDash: [],
        borderWidth: 4,
        showLine: true,
        zIndex: 100,
        order: 0
      });
    
      this.data = {
        labels: formattedLabels,
        datasets: datasets
      };
      this.options = {
        responsive: true,
        plugins: {
          legend: {
            display: true,
            position: 'top'
          }
        },
        scales: {
          y: {
            title: {
              display: true,
              text: this.layer.toUpperCase()==='VERTICALE'?'Spostamento verticale [mm]':'Spostamento lungo la LOS [mm]',
              font: {
                weight: 'bold'
              }
            }
          }
        }
      };
    }
    
    // Funzione per assegnare un colore diverso a ogni punto
    private getColor(index: number): string {
      const colors = ['#42A5F5', '#FFA726', '#66BB6A', '#FF7043', '#AB47BC']; // Espandibile se necessario
      return colors[index % colors.length];
    }
    

  loadMisurazioniPuntoLayer (idProgetto:number, idPunto:number, layer:string) {
    let tripletta:string = idProgetto + "_"+idPunto+ "_"+layer.toUpperCase();
    const documentRef = this.firestore.collection(environment.firebase.collectionMisurazioni).doc(tripletta);
    documentRef.get().subscribe((docSnapshot) => {
      if (docSnapshot.exists) {
        this.misurazione = docSnapshot.data() as Misurazione_Firestore;
        let labels = Object.keys(this.misurazione.misurazioni).filter(key => {
        return key !== '"SPAZIO"' && key !== "//" && key !== 'PID' && key !== 'lon' && key !== 'lat';
    });
        labels.sort((a, b) => {
          const dateA = parseInt(a.substring(1)); 
          const dateB = parseInt(b.substring(1));
          return dateA - dateB; 
        });
        const values = labels.map(label => this.misurazione.misurazioni[label]);
        const formattedLabels = labels.map(label => {
          const year = label.substring(1, 5);
          const month = label.substring(5, 7);
          const day = label.substring(7, 9);
          return `${day}/${month}/${year.substring(2)}`; 
        });
        
        // Calcolo della media
        //const media = this.calcolaMedia(values);
        //const mediaArray = Array(values.length).fill(media);
        
        this.data = {
          labels: formattedLabels,
          datasets: [
            {
              data: values,
              fill: false,
              borderColor: '#42A5F5',
              tension: 0.4,
              pointRadius: 3,      
              showLine: this.showLine,
              borderWidth: 1
            },
            /* {
              data: mediaArray,
              fill: false,
              borderColor: '#000000',
              tension: 0,
              pointRadius: 0,
              showLine: true,
              borderDash: [],
              borderWidth: 4,
              label: 'Media',
              zIndex: 100,
              order: 0
            } */
          ]  
        };  
      }else{
        this.logger.info("-> NESSUNA MISURAZIONE PER PUNTO "+ idPunto + " DEL PROGETTO "+ idProgetto + " SU LAYER "+ layer.toUpperCase());
      }
    });
    
  }

  // Funzione per calcolare la media di un array di numeri
  private calcolaMedia(values: number[]): number {
    if (values.length === 0) return 0;
    const sum = values.reduce((acc, val) => acc + val, 0);
    return sum / values.length;
  }

}
